import { __assign, __generator } from "tslib";
import { call, put, takeEvery } from 'redux-saga/effects';
import { initialize, requestFailure, requestSuccess } from './actionCreators';
import { request } from '../../xhr';
function getFakeData(_a) {
    var username = _a.params.username;
    if (process.env.NODE_ENV !== 'production') {
        var _b = require('@wix/da-sample-data'), users = _b.users, deviationsByType = _b.deviationsByType, Fake = _b.Fake, deviations = _b.deviations; // eslint-disable-line global-require
        var Chance = require('chance').Chance; // eslint-disable-line global-require
        var chance = new Chance();
        // TODO: Change to PapiDaSharedUserInfo when able
        var data = {
            user: __assign(__assign({}, (users.find(function (u) { return u.username === username; }) || chance.pickone(users))), { username: username, profile: {
                    tagline: 'Digital Artist',
                    profilePic: chance.pickone(deviationsByType.image),
                }, stats: {
                    watchers: chance.natural({ max: 40000 }),
                    friends: chance.natural({ max: 1000 }),
                } }),
            deviationsCount: chance.natural({ max: 999 }),
            description: Fake.makeEditorText(),
            featuredDeviations: chance.pickset(deviations, 10),
            mutualWatchedUsers: chance.pickset(users, 2),
            mutualWatchedUsersCount: 5,
        };
        return data;
    }
    return false;
}
function handleInitialize(action) {
    var username, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                username = action.payload.username;
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'user/info',
                        params: {
                            username: username,
                            expand: 'user.stats,user.profile,user.watch',
                        },
                    }, getFakeData)];
            case 1:
                result = _a.sent();
                if (!result) return [3 /*break*/, 3];
                return [4 /*yield*/, put(requestSuccess(username, result))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(requestFailure(username))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function UserAvatarPopoverRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(initialize, handleInitialize)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map